import PropTypes from 'prop-types';

export const IoDialogBasePropTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isShow: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export const IoDialogType = {
  Approve: 'approve',
  Decline: 'decline',
  Cancel: 'cancel',
};
